import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, from, lastValueFrom } from 'rxjs'; // Añadido 'from' y 'lastValueFrom'
import { catchError, switchMap } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { Router } from '@angular/router';
import { ServicioAutenticacion } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private router: Router,
    private authService: ServicioAutenticacion
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.authService.obtenerToken();
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (error.error instanceof Blob) {
            return this.handleBlobError(error);
          } else {
            return this.handleStandardError(error);
          }
        }
        return throwError(() => error);
      })
    );
  }

  private handleBlobError(error: HttpErrorResponse): Observable<never> {
    const blob = error.error as Blob;

    if (blob.type === 'application/json') {
      return from(blob.text()).pipe(
        switchMap((errorText) => {
          try {
            const errorObj = JSON.parse(errorText);
            if (errorObj && errorObj.message) {
              if (errorObj.message.toLowerCase().includes('token expirado')) {
                this.authService.handleSessionExpired();
              }
            }
          } catch (e) {
            console.error('No se pudo parsear el error como JSON:', e);
          }
          return throwError(() => error);
        })
      );
    } else {
      return this.handleStandardError(error);
    }
  }

  private handleStandardError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (error.error && typeof error.error === 'object' && error.error.message) {
      errorMessage = error.error.message;
    } else if (error.error && typeof error.error === 'string') {
      try {
        const parsedError = JSON.parse(error.error);
        if (parsedError.message) {
          errorMessage = parsedError.message;
        }
      } catch {
        errorMessage = error.error;
      }
    }

    if (
      errorMessage.toLowerCase().includes('token expirado') ||
      errorMessage.toLowerCase().includes('token expired') ||
      error.status === 401
    ) {
      this.authService.handleSessionExpired();
    } else {
      this.toastService.mostrarNotificacion(
        'Error de autenticación. Por favor ingrese nuevamente.',
        'error'
      );
      this.router.navigate(['/login']);
    }
    return throwError(() => error);
  }
}
